module.exports = __webpack_public_path__ + "img/image-11.09142c50.jpg";